__turbopack_context__.v({
  "floatBottomCenter": "Hero-module-scss-module__E0_eSG__floatBottomCenter",
  "floatBottomRight": "Hero-module-scss-module__E0_eSG__floatBottomRight",
  "floatTopLeft": "Hero-module-scss-module__E0_eSG__floatTopLeft",
  "floatTopRight": "Hero-module-scss-module__E0_eSG__floatTopRight",
  "floatingImage": "Hero-module-scss-module__E0_eSG__floatingImage",
  "logoAnimation": "Hero-module-scss-module__E0_eSG__logoAnimation",
  "logoScale": "Hero-module-scss-module__E0_eSG__logoScale",
});
